import Card from 'components/card/Card'
import OrderConfirmationFilter from './components/OrderConfirmationFilter'
import OrderConfirmationDetail from './components/OrderConfirmationDetail'
import {useOrderConfirmation} from './hooks/useOrder'

function OrderConfirmation() {
  const order = useOrderConfirmation()

  return (
    <div className="content-wrapper">
      {order.toastContainer}
      <Card dataTestId="card_order_confirmation">
        <Card.Header className="w-full pb-0" border={false}>
          <OrderConfirmationFilter
            invoiceNumber={order.invoiceNumber}
            setInvoiceNumber={(value) => order.setInvoiceNumber(value)}
            searchOrderWarehouse={order.searchOrder}
            isLoadingSearch={order.isDisabledInputFetch}
          />
        </Card.Header>
        <Card.Body>
          <div className="w-full">
            {order.orderConfirmationDetail === null ? <div className="flex flex-col items-center py-20">
              <img src="/media/socialSearch.svg"/>
              <h4 className="text-xl mt-5 text-[#858C95]">Belum Ada Invoice</h4>
            </div> : <OrderConfirmationDetail
              order={order.orderConfirmationDetail}
              isModalOpenUpdateOrderStatus={order.isModalOpenUpdateOrderStatus}
              isLoadingUpdateOrderStatus={order.isLoadingUpdateOrderStatus}
              setModalOpenUpdateOrderStatus={order.setModalOpenUpdateOrderStatus}
              updateOrderStatus={order.updateOrderStatus}/>}
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

export default OrderConfirmation




